import { cn } from '@fe-learner-common';
import { FC, LiHTMLAttributes } from 'react';
interface ListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  disabled?: boolean;
}

export const ListItem: FC<ListItemProps> = ({
  children,
  disabled,
  className,
}) => {
  return (
    <li
      role="article"
      className={cn(
        'lf:group lf:relative lf:isolate lf:mb-2 lf:flex lf:cursor-pointer lf:items-start lf:justify-between lf:gap-x-2 lf:rounded-lg lf:bg-white lf:transition-colors lf:hover:bg-neutral-100',
        'lf:after:content lf:after:absolute lf:after:-bottom-2 lf:after:left-4 lf:after:right-4 lf:after:border-b-1 lf:after:border-neutral-100',
        {
          'lf:cursor-not-allowed': disabled,
        },
        className,
      )}
    >
      {children}
    </li>
  );
};
